import React, { Component } from "react"
import { Link } from "react-router-dom"
import * as constants from "../constants"
export default class TableLayout extends Component {
  render() {
    var additionalButtons = this.props.additionalButtons || []
    return (
      <div className="container-fluid">
        <div className={this.props.sizeClass}>
          <div className="card card-plain">
            <div
              className="card-header text-center row"
              data-background-color={this.props.backgroundColor}
            >
              <div className="col-md-2">
                {this.props.headerButtons.map((button, key) => {
                  if (
                    button.icon === "delete" &&
                    constants.haveRole(1)
                  ) {
                    return null
                  } else {
                    return (
                      <Link
                        key={key}
                        title={button.title}
                        className="btn btn-group btn-simple btn-xs col-md-3"
                        to={button.link}
                      >
                        <i
                          className="icon-header material-icons"
                          style={{ fontSize: 30, top: -5 }}
                        >
                          {button.icon}
                        </i>
                      </Link>
                    )
                  }
                })}
              </div>
              <div className="col-md-8">
                <h4 className="title text-center auto-width">
                  {this.props.title}
                </h4>
                <p className="category text-center auto-width">
                  {this.props.subtitle}
                </p>
              </div>
              <div className="col-md-2">
                {additionalButtons.map((button, key) => {
                  return (
                    <button
                      key={key}
                      title={button.title}
                      onClick={event => button.callBack(event)}
                      className="pull-right btn btn-group btn-simple btn-xs col-md-3 print-button"
                    >
                      <i
                        className="icon-header material-icons"
                        style={{ fontSize: 30, top: -5 }}
                      >
                        {button.icon}
                      </i>
                    </button>
                  )
                })}
              </div>
            </div>
            <div
              style={{ maxWidth: "100%" }}
              className="table-responsive container"
            >
              <div className="row">
                {this.props.filter && (
                  <div className="form-group is-empty">
                    <input
                      onChange={this.props.filter}
                      type="text"
                      className="form-control"
                      placeholder={this.props.searchLabel}
                    />
                    <span className="material-input" />
                  </div>
                )}
                {this.props.children}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TableLayout.js